<template>
  <div>
    <v-card>
      <v-tabs
        v-model="tab"
        align-with-title
        background-color="amber"
        grow
      >
        <v-tabs-slider color="blue"></v-tabs-slider>

        <v-tab @click="refreshTab('table')">Update Scheduler</v-tab>
        <v-tab @click="refreshTab('daily')">Daily Activity</v-tab>
        <v-tab @click="refreshTab('hourly')">Hourly Activity</v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <UpdateSchedulerTableGtps ref="table"/>
        </v-tab-item>
        <v-tab-item>
          <DailyActivityGtps ref="daily"/>
        </v-tab-item>
        <v-tab-item>
          <HourlyActivityGtps ref="hourly"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import UpdateSchedulerTableGtps from './UpdateSchedulerTableGtps.vue';
import DailyActivityGtps from './DailyActivityGtps.vue';
import HourlyActivityGtps from './HourlyActivityGtps.vue';

export default {
  components: {
    UpdateSchedulerTableGtps,
    DailyActivityGtps,
    HourlyActivityGtps,
  },

  data() {
    return {
      tab: 0,
    };
  },

  methods: {
    refreshTab(tab) {
      if (this.$refs[tab]) {
        // this.$refs[tab].getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
